export enum Platform {
  Ios = 'ios',
  Android = 'android',
  Desktop = 'desktop',
}

export const IOS_USER_AGENT_PATTERN = /iPhone|iPad/

export function platformForPointer(isCoarsePointer: boolean, userAgent: string): Platform {
  if (typeof isCoarsePointer !== 'boolean') throw new Error('Platform detection requires a pointer-type boolean')
  if (typeof userAgent !== 'string') throw new Error('Platform detection requires a user-agent string')
  if (!isCoarsePointer) return Platform.Desktop
  return IOS_USER_AGENT_PATTERN.test(userAgent) ? Platform.Ios : Platform.Android
}
